// utils
import { getCurrentDate } from "src/utils/dateHelper";

// cache store
import configure from "src/utils/store";

export const getCategoriesCache = async (_userID) => {
  let data = {
    userID: _userID,
  };

  const api = await configure();

  const response = await api({
    method: "POST",
    url: `/Category`,
    data: data,
    params: data.categoryId,
  });

  return response;
};

export const getEventByCategoryCache = async (_data) => {
  let now = getCurrentDate();

  // let data = {
  //   // userId: _data?.userId || 0,
  //   userId: 0,
  //   latitude: _data?.lat || "40.303707",
  //   longitude: _data?.lng || "-72.92622",
  //   categoryId: _data.catgId,
  //   pageNumber: _data?.pageNumber || 1,
  //   totalPageCount: _data?.limit || 12,
  //   // accessToken: _data?.accessToken || "",
  //   accessToken: "",
  //   DateTimeNow: now.prettier.dateTimeNow,
  //   IsFromWeb: "true",
  //   sortOrder: "date",
  // };

  // for /NewEvent api data request.
  let data = {
    accessToken: "",
    latitude: _data?.lat || "41.7657461",
    longitude: _data?.lng || "-72.7151064",
    categoryId: _data.catgId,
    dateTimeNow: now.prettier.dateTimeNow,
    totalPageCount: _data?.limit || 12,
    pageNumber: _data?.pageNumber || 1,
    sortOrder: "date",
    isFromWeb: "1",
  };

  const api = await configure();

  const response = await api({
    method: "POST",
    url: `/NewEvent`,
    data: data,
    params: data.categoryId,
  });

  return response;
};

export const clearCache = async () => {
  const api = await configure();
  api.cache.clear();
};

export const clearCacheCategory = async (_id) => {
  const api = await configure();
  api.cache.removeItem(_id);
};
